'use client';

import React from 'react';
import { formatUid, getItemUid, type TagItem } from '../utils/metadata-helpers';

type TagSectionProps = {
    title: string;
    items: TagItem[];
    uidPrefix: string;
    dataTestId?: string;
};

export const TagSection: React.FC<TagSectionProps> = ({ title, items, uidPrefix, dataTestId }) => {
    if (!items?.length) {
        return null;
    }

    const validUids = items.map(getItemUid).filter(Boolean) as string[];

    if (!validUids.length) {
        return null;
    }

    return (
        <div className="gip-section" data-testid={dataTestId}>
            <h3 className="gip-section-title">{title}</h3>
            <div className="gip-tags">
                {validUids.map((uid) => (
                    <span key={uid} className="gip-tag">
                        {formatUid(uid, uidPrefix)}
                    </span>
                ))}
            </div>
        </div>
    );
};
